import { path } from 'ramda';

import { FEATURE_NAME as $, SUCCESS, ERROR, ERRORS, LOADING } from './consts';

export const getSuccess = (id) => path([$, id, SUCCESS]);
export const getError = (id) => path([$, id, ERROR]);
export const getErrors = (id) => path([$, id, ERRORS]);
export const getLoading = (id) => path([$, id, LOADING]);
